import React from "react";

import config from "../config";
import ConsentModeHelperWeb from "../lib/ConsentModeHelper/ConsentModeHelperWeb";
import { showModal } from "../lib/react-redux-modal-provider";
import CookiesConsentEvent from "../lib/SalesManago/events/CookiesConsentEvent";
import withIsHttpRequestsDone from "../web/hocs/withIsHttpRequestsDone";
import withSmEventTracker from "./withSmEventTracker";

export default function withConsentSettingsWeb(WrappedComponent) {
  @withSmEventTracker
  @withIsHttpRequestsDone
  class WithConsentSettingsWeb extends React.Component {
    constructor() {
      super();
      this.state = { needsConsent: false };
      this.consentModalOpened = false;
    }

    openConsentModalIfNeeded() {
      const { trackSMEvent, isHttpRequestsDone } = this.props;

      if (
        this.consentModalOpened ||
        !this.state.needsConsent ||
        !isHttpRequestsDone ||
        !ConsentModeHelperWeb.shouldShowModal()
      ) {
        return;
      }

      this.consentModalOpened = true;
      this.setState({ needsConsent: false });

      showModal("CookieModal", {
        onApplySettings: settings => {
          if (ConsentModeHelperWeb.validateSettings(settings)) {
            ConsentModeHelperWeb.applyConsentSettings(settings);

            const smEvent = new CookiesConsentEvent(settings);
            trackSMEvent(smEvent);
          }
        }
      });
    }

    componentDidMount() {
      const { userData } = this.props;

      // This needs to happen before GTM scripts execution
      if (config.trackSMEvents && userData?.contact_id) {
        window._smclientid = userData.contact_id;
      }

      ConsentModeHelperWeb.applyDefaultConsent();

      const consentSettings = ConsentModeHelperWeb.attemptLoadConsentSettings();

      if (
        consentSettings &&
        ConsentModeHelperWeb.validateSettings(consentSettings)
      ) {
        ConsentModeHelperWeb.applyConsentSettings(consentSettings);
      } else {
        this.setState({ needsConsent: true }, () => {
          this.openConsentModalIfNeeded();
        });
      }
    }

    componentDidUpdate(prevProps) {
      const { userData } = this.props;

      if (
        config.trackSMEvents &&
        userData?.contact_id &&
        !prevProps.userData?.contact_id
      ) {
        window._smclientid = userData.contact_id;
      }

      this.openConsentModalIfNeeded();
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  return WithConsentSettingsWeb;
}
